<template>
  <!-- Accordion with a photo (S2_Interactive): open a line and the photo
       beside it changes. One open at a time; works without JavaScript as
       plain open sections in the server render. -->
  <SectionBand :heading="section.heading || section.title" :variant="variant" :background="section.background" label="Questions and photos">
    <div class="s2-acc" :data-side="section.layout === 'right' ? 'right' : 'left'">
      <div class="s2-acc__photo">
        <Media v-if="current?.image" :key="active" :media="current.image" ratio="4 / 5" class="s2-acc__img" />
      </div>
      <div class="s2-acc__list">
        <div v-for="(it, i) in items" :key="i" class="s2-acc__item" :class="{on: i === active}">
          <h3 class="s2-acc__h">
            <button type="button" :id="`${uid}-b${i}`" :aria-expanded="i === active" :aria-controls="`${uid}-r${i}`" @click="active = i">
              <span>{{ it.title }}</span><span aria-hidden="true">{{ i === active ? '−' : '+' }}</span>
            </button>
          </h3>
          <div v-show="i === active" :id="`${uid}-r${i}`" role="region" :aria-labelledby="`${uid}-b${i}`" class="s2-acc__body t-body">
            <div class="s2-prose" v-html="html(it.text)" />
            <Media v-if="it.image" :media="it.image" ratio="16 / 10" class="s2-acc__inline" />
          </div>
        </div>
      </div>
    </div>
  </SectionBand>
</template>

<script setup>
import {computed, ref, useId} from "vue";
import SectionBand from "../shared/SectionBand.vue";
import Media from "../shared/Media.vue";
import {contentHtml} from "@/utils/contentHtml.js";

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const items = computed(() => (Array.isArray(props.section.items) ? props.section.items : []).filter((it) => it && it.title));
const active = ref(0);
const current = computed(() => items.value[active.value]);
const uid = useId();
const html = (t) => contentHtml(t || "");
</script>

<style scoped>
.s2-acc { display: grid; grid-template-columns: 1fr 1.1fr; gap: clamp(1.5rem, 4vw, 3.5rem); align-items: start; }
.s2-acc[data-side="right"] .s2-acc__photo { order: 2; }
.s2-acc__photo { position: sticky; top: 6rem; }
.s2-acc__item { border-top: 1px solid var(--t-line); }
.s2-acc__item:last-child { border-bottom: 1px solid var(--t-line); }
.s2-acc__h { margin: 0; }
.s2-acc__h button { width: 100%; display: flex; justify-content: space-between; gap: 1rem; padding: 1.05rem 0; background: none; border: 0; text-align: left; font: 700 1.08rem var(--t-font-display); color: var(--t-ink); cursor: pointer; min-height: 44px; }
.s2-acc__item.on .s2-acc__h button span:last-child { color: var(--t-accent); }
.s2-acc__body { padding: 0 0 1.1rem; }
.s2-acc__inline { display: none; margin-top: 1rem; }
@media (max-width: 760px) {
  .s2-acc { grid-template-columns: 1fr; }
  .s2-acc__photo { display: none; }
  .s2-acc__inline { display: block; }
}
</style>
